import { useTranslation } from "react-i18next";
import type { Publication, PublicationState } from "../../../api/knowledgeData/releaseDecoders";
import Chip from "../../../ui/feedback/Chip";
import type { ChipTone } from "../../../ui/styles/chipStyles";

const TONE: Readonly<Record<PublicationState, ChipTone>> = {
  requested: "info",
  exporting: "info",
  configuring: "info",
  applying: "info",
  published: "success",
  failed: "danger",
};

/** A release's state in ResearchSpace, as a chip; with the reason when it failed. A published
 * release that is no longer the project's live one was replaced by a later publication. */
export default function ResearchSpaceState({ publication, live, detailed = false }: { publication: Publication | null; live: boolean; detailed?: boolean }) {
  const { t } = useTranslation();
  if (publication === null) return null;
  const replaced = publication.state === "published" && !live;
  return (
    <span className="inline-flex flex-col items-start gap-0.5">
      <Chip tone={replaced ? "neutral" : TONE[publication.state]} size="compact">
        {replaced ? t("data.researchSpace.replaced") : t(`data.researchSpace.states.${publication.state}`)}
      </Chip>
      {detailed && publication.problem !== null ? (
        <span className="app-status-text-error text-xs">{publication.problem.detail}</span>
      ) : null}
    </span>
  );
}
